import Vue from 'vue'
import Home from './views/Home_old.vue'
import Home_v2 from './views/Home_v2.vue'
import VueRouter from 'vue-router'
// import { IonicVueRouter } from '@ionic/vue'
// import Devices from './utils/Devices'
import Test from './views/Test'
import Search from './views/Search'
import Detail from './views/Detail'
import store from './store/index'
import Interest from './views/Interest'
import More from './views/More'
import Notifications from './utils/Notifications'
import Policy from './views/Policy'
import HuesikInGrovePrivacy from './views/HuesikInGrovePrivacy'
import HuesikInGrovePoint from './views/HuesikInGrovePoint'
import CallPage from './views/CallPage'
import Privacy from './views/Privacy'
import Register from './views/Register'
import Contract from './views/Contract'

// const currentRouter = Devices.isMobile() ? IonicVueRouter : VueRouter
const currentRouter = VueRouter
Vue.use(currentRouter)

const router = new currentRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/tt',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'home',
      component: Home_v2
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/detail/:pk',
      name: 'detail',
      component: Detail,
      meta: {
        title: '고시원 찾을 땐? 고시락'
      }
    },
    {
      path: '/interest',
      name: "interest",
      component: Interest
    },
    {
      path: '/View/:beforeId?',
      redirect: (to) => {
        const { params } = to
        return {
          path: `/detail/${params.beforeId}?before=true`
        }
      }
    },
    {
      path: '/more',
      component: More,
      name: 'more'
    },
    {
      path: '/policy',
      component: Policy,
      name: 'policy'
    },
    {
      path: '/call-page',
      component: CallPage,
      name: 'call-page'
    },
    {
      path: '/register',
      component: Register,
      name: 'register'
    },
    {
      path: '/contract',
      component: Contract,
      name: 'contract'
    },
    {
      path: '/privacy',
      component: Privacy,
      name: 'privacy'
    },
    {
      path: '/huesik_in_grove/privacy',
      component: HuesikInGrovePrivacy,
      name: 'huesik_in_grove_privacy'
    },
    {
      path: '/point/:uuid',
      component: HuesikInGrovePoint,
      name: 'huesik_in_grove_point'
    }
  ]
})

// router gards
router.beforeEach((to, from, next) => {
  const isAuthentication = store.getters.getAccessToken
  console.log(to)
  console.log(from)
  if (!isAuthentication && to.meta.public === false) {
    Notifications.alert('로그인 후 이용하실 수 있는 서비스 입니다.')
    this.$modal.show('login-modal')
  } else if (!isAuthentication && to.meta.public) {
    next()
  } else {
    next()
  }
})

//router.afterEach((to, from, next) => {
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
